


export const localStorageKeys = {
    
    userId:"userId",
    userName:"userName",
    userCoverPicture:"userCoverPicture",
    userFirstName:"userFirstName",
    userLastName:"userLastName",
    userEmail:"userEmail",
    userPhone:"userPhone",
    userDescription:"userDescription",
    profileRole:"profileRole",


    productsData : "productsData",
    ordersData : "ordersData",
    publicationsData : "publicationsData",
    bannersData : "bannersData",
    categorysData : "categorysData",
    customersData : "customersData",
    adminsData : "adminsData",
    basketsData : "basketsData",
    postalCodesData : "postalCodesData",
    notificationsData : "notificationsData",
    transactionsData : "transactionsData",
    postalcodesData : "postalcodesData",

}